import React, { useCallback } from 'react'
import { Field as FinalField } from 'react-final-form'
import { FinalTextFieldProps, TextField, TextFieldProps } from './TextField'

/** @deprecated Use InputNumber from `@chilipiper/design-system/src/new` instead */
export const NumberTypeField = ({
  name,
  hideNumberArrows,
  onBlur,
  onChange,
  ...props
}: TextFieldProps) => {
  const numberType = hideNumberArrows ? '' : 'number'
  const triggerChangeWithUpdatedValue = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, value: string) => {
      onChange?.({
        ...event,
        target: {
          ...event.target,
          value,
        },
      })
    },
    [onChange]
  )

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const valueWithoutText = getValueWithoutText(e.target.value)
      triggerChangeWithUpdatedValue(e, valueWithoutText)
    },
    [triggerChangeWithUpdatedValue]
  )

  const handleBlurEvent = useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      const { value } = e.target
      const withoutText = getValueWithoutText(value)
      const withoutLeadingZeroes = withoutText.replace(/^0+/, '')
      const finalValue = withoutLeadingZeroes || '0'
      onBlur?.(e)
      if (value !== finalValue) {
        triggerChangeWithUpdatedValue(e, finalValue)
      }
    },
    [onBlur, triggerChangeWithUpdatedValue]
  )
  return (
    <TextField
      data-test-id={`NumberTypeField-${name}`}
      type={numberType}
      name={name}
      id={name}
      onChange={handleChange}
      onBlur={handleBlurEvent}
      {...props}
    />
  )
}

/** @deprecated Use InputNumber from `@chilipiper/design-system/src/new` instead */
export const FinalNumberTypeField = ({ name, id, parse, ...props }: FinalTextFieldProps) => {
  return (
    <FinalField name={name} id={id} parse={parse}>
      {({ input, meta }) => (
        <NumberTypeField {...props} {...input} id={id} error={meta.touched && meta.error} />
      )}
    </FinalField>
  )
}
const getValueWithoutText = (value: string) => value.replace(/[\D]/g, '')
